export default [
  {
    content: "자율안전확인 신고 제품 사용('13.3.1. 이후 제조·출고 제품) \n[적용제외 : 식품용, 시간당 파쇄 또는 분쇄용랑이 50킬로그램 미만인 것]",
    isChecked: "",
    title: "관리적 사항",
  },
  {
    content: "안전보건표지 부착 \n[위험이 예상되는 곳 표지판 설치, 외국인근로자가 있는 경우 자국어로 표시]",
    isChecked: "",
    title: "관리적 사항",
  },
  {
    content: "투입구 덮개 설치 및 연동장치(인터록장치) 정상작동 확인",
    isChecked: "",
    title: "관리적 사항",
  },
  {
    content: "방호장치 임의 해체금지(연동장치 등)",
    isChecked: "",
    title: "안전장치 설치 및 사용상태",
  },
  {
    content: "기계의 동력차단장치(비상정지장치 등) 설치 및 정상작동 확인",
    isChecked: "",
    title: "안전장치 설치 및 사용상태",
  },
  {
    content: "전기 기계·기구 등의 충전부 방호\n" +
      "  [제어반 전기기계·기구는 물기(습기)가 유입되지 않도록 밀봉처리)",
    isChecked: "",
    title: "안전장치 설치 및 사용상태",
  },
  {
    content: "투입물 증 인화성 물질 포함으로 화재·폭발 위험 확인",
    isChecked: "",
    title: "안전장치 설치 및 사용상태",
  },
  {
    content: "작업장 및 해당 설비 장소 수시 정리·정돈·청소 실시\n" +
      "  [미끄러지거나 걸려 넘어짐 예방 조치 실시]",
    isChecked: "",
    title: "안전장치 설치 및 사용상태",
  },
  {
    content: "분쇄기·파쇄기 고소부위(투입구 등) 작업 통로 확보 및 안전 조치\n" +
      "  [적절한 작업발판 및 안전난간 설치]",
    isChecked: "",
    title: "안전장치 설치 및 사용상태",
  },
  {
    content: "정비 등의 작업 시의 운전정지 등 조치 \n" +
      "  [불시기동방지를 위한 동력전원 차단, 잠금장치 및 \"점검 중 조작금지 \" 표지 게시)",
    isChecked: "",
    title: "정비·청소·검사·수리·교체 작업 시",
  },
  {
    content: "비상 시 연락조치 가능한 상태에서 작업",
    isChecked: "",
    title: "정비·청소·검사·수리·교체 작업 시",
  },
  {
    content: "분쇄물 과다투입 여부 확인 및 적정용랑 투입 준수",
    isChecked: "",
    title: "근로자 준수사항",
  },
  {
    content: "분쇄기·파쇄기 조작방법 및 안전작업 절차 준수\n" +
      "  [분쇄물 적정용랑 투입, 투입용 보조기구(수공구) 사용, 방호장치 해체 금지 등, 작업의 편의성을 위해 가동 중인 상태에서 작업 금지)",
    isChecked: "",
    title: "근로자 준수사항",
  },
  {
    content: "적절한 작업복, 보호구 등의 착용\n" +
      "  [작업에 알맞은 작업모 또는 작업복 착용)",
    isChecked: "",
    title: "근로자 준수사항",
  },
];
